import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { authHeader, config } from '../_helpers';
import { applicantsActions, permissionActions } from '../_actions';
import { Link } from 'react-router-dom';
import '../assets/styles/applicants.css';
import { getApplicantStatus } from '_utils/utils';
import { formatDateTime } from '_helpers/helpers';
import PropTypes from 'prop-types';

// To format the phone number
function formatPhoneNumber(s) {
  const s2 = ('' + s).replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}

function formatDate(date) {
  let formattedDate = moment(date);
  if (formattedDate.isValid()) {
    formattedDate = formattedDate.format('MM/DD/YYYY');
    return formattedDate;
  } else {
    return '-';
  }
}

const fieldDetails = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone#' },
  { key: 'date', label: 'Date' },
  { key: 'area', label: 'Area' },
  { key: 'cert', label: 'Cert. Status' },
  { key: 'job_status', label: 'Status' },
  { key: 'resource_name', label: 'Crew' },
  { key: 'performed', label: 'Performed By' },
  { key: 'interviewDate', label: 'Interview Form Submitted Date' },
  { key: 'updatedAt', label: 'Updated At' },
]

class ArchivedApplicant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: true,
      applicationItem: [],
      showComponent: false,
      type: 'archive',
      keyword: '',
      resultData: [],
      order: true,
      sort: 'date',
      // TODO: we might not need this as we have order and sort state already
      sortOrder: {},
      orderAll: 'asc',
      dateSort: 'desc',

      keySearch: '',
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.sorting = this.sorting.bind(this);
  }
  componentDidMount() {
    this.componentWillReceiveProps(this.props);
    this.props.dispatch(applicantsActions.getArchived());
    this.props.dispatch(permissionActions.getPermission());
  }

  componentWillReceiveProps(nextProps) {
    window.addEventListener('scroll', this.handleScroll);
    const { applicants } = nextProps;
    if (applicants.notes) {
      if (applicants.notes.success) {
        this.props.dispatch(applicantsActions.getArchived());
      }
    }
    if (applicants.items) {
      this.setState({ resultData: applicants.items.data });

      let applicationItem = [];
      if (applicants.items.data.data) {
        if (applicants.items.data.data?.length > 0) {
          applicants.items.data.data.map((item, index) => {
            applicationItem.push(
              <div className='applicant_item' key={index}>
                <div className='basic_info'>
                  <div className='appln_item'>
                    {item.first_name + ' ' + item.last_name}
                  </div>
                  <div className='appln_item'>
                    {item.email_address ? (
                      <a
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        className='phone_email_link'
                        href={`mailto:${item.email_address}`}
                        target='_top'
                      >
                        {item.email_address}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='appln_item'>
                    {item.phone_number ? (
                      <a
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        className='phone_email_link'
                        href={`tel:${item.phone_number}`}
                        target='_top'
                      >
                        {formatPhoneNumber(item.phone_number)}
                      </a>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='appln_item'>{formatDate(item.date)}</div>
                  <div className='appln_item'>{item.area}</div>
                  <div className='appln_item'>{item.cert_status}</div>
                  <div className='appln_item'>
                    {getApplicantStatus[item.status]}
                  </div>
                  <div className='appln_item'>{item.resource_name ?? '-'}</div>
                  <div className='appln_item'>{item.performed_by ?? '-'}</div>
                  <div className='appln_item'>
                    {formatDate(item.date_of_submission)}
                  </div>
                  <div className='appln_item'>
                    {formatDateTime(item.status_change_date) ?? '-'}
                  </div>
                </div>
                <div className='actions' style={{ display: 'flex' }}>
                  {!item?.interview_form_count ? (
                    <div
                      className='applicant_no_interview_forms_icon'
                      style={{
                        position: 'unset',
                        maxWidth: 40,
                        transform: 'unset',
                      }}
                    >
                      <img
                        src={`${config.assetUrl}icons/interview_form_not_filled.svg`}
                        alt='Interview form not filled'
                      />
                      <span className='applicant_no_interview_forms_tooltip'>
                        No interview forms are available.
                      </span>
                    </div>
                  ) : null}
                  <Link to={'/applicant-view/' + item.hash}>
                    <img
                      alt={item.first_name + ' ' + item.last_name}
                      src={require('../assets/images/view.png').default}
                      className='view'
                    />
                  </Link>
                </div>
              </div>,
            );
            return applicationItem;
          });
        } else {
          applicationItem.push(
            <div className='applicant_item'>
              <div className='basic_info'>
                <p className='noResult'>No search results were found</p>
              </div>
            </div>,
          );
        }
      }
      this.setState({ applicationItem: applicationItem });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleChange() {}
  goBack() {
    this.props.goBack();
  }

  sorting(sort, e) {
    this.setState({ order: !this.state.order, sort });

    const sortOrder = {};
    fieldDetails.forEach((field) => {
      const key = field.key;
      sortOrder[key] = key === sort ? !this.state.sortOrder[key] : false;
    });

    this.setState({
      sortOrder
    });

    let order;
    if (this.state.order) {
      order = 'asc';
    } else {
      order = 'desc';
    }
    this.setState({ orderAll: order, dateSort: order }, function () {});
    let data = new FormData();
    data.append('keyword', this.state.keySearch);
    data.append('sort', sort);
    data.append('order', order);
    data.append('type', this.state.type);
    this.props.dispatch(applicantsActions.searchApplicants(data));
  }

  handleSearch() {
    const text = this.state.keySearch;
    this.setState({ keyword: text });
    let data = new FormData();
    data.append('keyword', text);
    data.append('type', this.state.type);
    data.append('sort', this.state.sort);
    if (this.state.sort === 'date') {
      data.append('order', this.state.dateSort);
    } else {
      data.append('order', this.state.orderAll);
    }
    this.props.dispatch(applicantsActions.searchApplicants(data));
  }
  handleFilter(event) {
    const option = event.target.value;
    this.setState({ type: option });
    let data = new FormData();
    data.append('keyword', this.state.keyword);
    data.append('type', option);
    data.append('sort', this.state.sort);
    if (this.state.sort === 'date') {
      data.append('order', this.state.dateSort);
    } else {
      data.append('order', this.state.orderAll);
    }
    this.props.dispatch(applicantsActions.searchApplicants(data));
  }
  viewDetails(hash) {
    this.props.viewDetails(hash, 'archived');
  }
  sendMail(email) {
    this.props.sendMail(email);
  }

  updateNotes(hash, e) {
    const { permission } = this.props;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }
    if (permList.includes('Update Applicant Note')) {
      let data = new FormData();
      data.append('hash', hash);
      data.append('note', e.target.value);
      this.props.dispatch(applicantsActions.updateNote(data));
    }
  }

  handleScroll(event) {
    let method;
    let wrap = document.getElementById('right_sidebar'),
      contentHeight = wrap.offsetHeight,
      yOffset = window.pageYOffset,
      y = yOffset + window.innerHeight,
      applicationItem = [];
    if (y >= contentHeight) {
      let data = this.state.resultData;

      if (data.current_page < data.last_page && this.state.flag !== false) {
        let requestOptions = {};
        if (data.next_page_url.indexOf('search') !== -1) {
          method = 'POST';
          let bdata = new FormData();
          bdata.append('keyword', this.state.keySearch);
          bdata.append('type', this.state.type);
          bdata.append('sort', this.state.sort);
          if (this.state.sort === 'date') {
            bdata.append('order', this.state.dateSort);
          } else {
            bdata.append('order', this.state.orderAll);
          }
          requestOptions = {
            method: method,
            headers: authHeader(),
            body: bdata,
          };
        } else {
          method = 'GET';
          requestOptions = {
            method: method,
            headers: authHeader(),
          };
        }
        fetch(data.next_page_url, requestOptions)
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            this.setState({ resultData: data.data });
            data.data.data.map((item, index) => {
              applicationItem.push(
                <div className='applicant_item' key={index}>
                  <div className='basic_info'>
                    <div className='appln_item'>
                      {item.first_name + ' ' + item.last_name}
                    </div>
                    <div className='appln_item'>
                      {item.email_address ? (
                        <a
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                          className='phone_email_link'
                          href={`mailto:${item.email_address}`}
                          target='_top'
                        >
                          {item.email_address}
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className='appln_item'>
                      {item.phone_number ? (
                        <a
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                          className='phone_email_link'
                          href={`tel:${item.phone_number}`}
                          target='_top'
                        >
                          {formatPhoneNumber(item.phone_number)}
                        </a>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className='appln_item'>{formatDate(item.date)}</div>
                    <div className='appln_item'>{item.area}</div>
                    <div className='appln_item'>{item.cert_status}</div>
                    <div className='appln_item'>
                      {getApplicantStatus[item.status]}
                    </div>
                    <div className='appln_item'>
                      {item.resource_name ?? '-'}
                    </div>
                    <div className='appln_item'>{item.performed_by ?? '-'}</div>
                    <div className='appln_item'>
                      {formatDate(item.date_of_submission)}
                    </div>
                    <div className='appln_item'>
                      {item.status_change_date ?? '-'}
                    </div>
                  </div>
                  <div className='actions' style={{ display: 'flex' }}>
                    {!item?.interview_form_count ? (
                      <div
                        className='applicant_no_interview_forms_icon'
                        style={{
                          position: 'unset',
                          maxWidth: 40,
                          transform: 'unset',
                        }}
                      >
                        <img
                          src={`${config.assetUrl}icons/interview_form_not_filled.svg`}
                          alt='Interview form not filled'
                        />
                        <span className='applicant_no_interview_forms_tooltip'>
                          No interview forms are available.
                        </span>
                      </div>
                    ) : null}
                    <Link to={'/applicant-view/' + item.hash} target='_blank'>
                      <img
                        alt={item.first_name + ' ' + item.last_name}
                        src={require('../assets/images/view.png').default}
                        className='view'
                        onClick={this.viewDetails.bind(this, item.hash)}
                      />
                    </Link>
                  </div>
                </div>,
              );
              return applicationItem;
            });
            this.setState({
              applicationItem: [
                ...this.state.applicationItem,
                ...applicationItem,
              ],
            });
          })
          .catch((err) => console.log(err));
      }
    }
  }
  render() {
    const applicants = this.props.applicants;
    
    if (applicants.items) {
      return (
        <div className='applicants_container'>
          <div className='breadcrumbs'>
            <span onClick={this.goBack.bind(this)} className='green'>
              Applicants
            </span>{' '}
            / Archived Applicants
          </div>
          <div className='page_title'>
            <h1>Archived Applicants</h1>
          </div>
          <div className='top_btn_group' />
          <div className='applicants_inner_head inner_head inner_head_mob'>
            <div className='col-xs-12 col-sm-12 col-md-6'>
              <select
                className='applicant_filter'
                name='filter'
                value={this.state.type ? this.state.type : 'archive'}
                onChange={this.handleFilter.bind(this)}
              >
                <option value='archive'>All</option>
                <option value='hire'>Was Hired</option>
                <option value='remove'>Not Selected</option>
                <option value='donthire'>Do Not Hire</option>
                <option value='duplicate'>Duplicate & Archive</option>
              </select>
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6'>
              <div className='right_inputs_wrapper'>
                <input
                  style={{ float: 'none', marginLeft: 'auto' }}
                  type='text'
                  name='keyword'
                  defaultValue={this.state.keySearch}
                  className='applicant_search'
                  value={this.state.keySearch}
                  placeholder='Search...'
                  onChange={(e) => this.setState({ keySearch: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      this.handleSearch(); // Trigger search on Enter key press
                    }
                  }}
                  autoComplete='off'
                />
                <button
                  style={{ height: '38px', marginLeft: '5px' }}
                  onClick={this.handleSearch}
                  className='button'
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          <div
            className='inner_container archived_applicant col-lg-12'
            id='applicants_inner'
          >
            <div className='clearFix' />
            <div
              className='applicants_list'
              id='applicants_list'
              onScroll={this.handleScroll}
            >
              <div className='appln_list_header'>
                {
                  fieldDetails.map((field) => {
                    const className = this.state.sortOrder[field.key] ? 'desc' : 'asc';
                    return (
                      <div
                        key={field.key}
                        className='list_item_head'
                        onClick={this.sorting.bind(this, field.key)}
                      >
                        {field.label}
                        <span className={`sort-arrow ${className}`} />
                      </div>
                    )
                  })
                }
              </div>
              {this.state.applicationItem}
            </div>
          </div>
        </div>
      );
    }
    // Showing loader
    return (
      <div className='applicants_container archived_page'>
        <div className='page_title'>
          <h1>Archived Applicants</h1>
        </div>
        <div className='top_btn_group' />
        <div
          className='inner_container archived_applicant col-lg-12'
          id='applicants_inner'
        >
          <center
            id='feedLoader'
            className={this.state.loader ? this.state.loader : ''}
          >
            <img
              alt='Loader'
              src={require('../assets/images/loader.gif').default}
            />
          </center>
        </div>
      </div>
    );
  }
}

ArchivedApplicant.propTypes = {
  dispatch: PropTypes.func.isRequired,
  applicants: PropTypes.object,
  permission: PropTypes.object,
  goBack: PropTypes.func.isRequired,
  viewDetails: PropTypes.func.isRequired,
  sendMail: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { applicants, permission } = state;
  return {
    applicants,
    permission,
  };
}
const connectedHomePage = connect(mapStateToProps)(ArchivedApplicant);
export { connectedHomePage as ArchivedApplicant };
